import { serviceCreate, merge } from "./modules/request";
//这种方式可以采用单个项目的接口，也可以使用多个项目的接口，看自己的项目情况而定
let http = serviceCreate({
  baseURL: "https://core.kaixinchuichui.cn/admin/index.php",
  timeout: 6000000, //请求超时
  emulateJSON: true //默认表单提交
});

export function uploadFs(params, config) { 
  return http.post(
  "/api/upload/fs_file",
  params,
  merge(config, { emulateJSON: false })
);
}
export function uploadFsDel(params, config) { 
  return http.post(
  "/fsapi/feishuDate/del",
  params,
  merge(config, { emulateJSON: false })
);
}
export function uploadFsDownload(params, config) { 
  return http.post(
  "/fsapi/feishuDate/download",
  params,
  merge(config, { emulateJSON: false })
);
}



export function allFiles(params, config) {
  return http.get("/fsapi/feishuDate/all_files", merge(config, { params }));
}

export function filesInfo(params, config) {
  return http.get("/fsapi/feishuDate/info_details", merge(config, { params }));
}
  export function getMenu(params, config) {
    return http.get("/fsapi/menu/home", merge(config, { params }));
  }

  export function getMember(params, config) { 
    return http.post(
    "/fsapi/menu/member_list",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function setMemberPower(params, config) { 
    return http.post(
    "/fsapi/menu/menu_power",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  
  export function delMenu(params, config) { 
    return http.post(
    "/fsapi/menu/del_menu",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function addMenu(params, config) { 
    return http.post(
    "/fsapi/menu/add_menu",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  export function editMenu(params, config) { 
    return http.post(
    "/fsapi/menu/edit_menu",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function getHeadr(params, config) { 
    return http.post(
    "/fsapi/menu/get_head",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  export function crateFolder(params, config) { 
    return http.post(
    "/fsapi/menu/create_folder",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function crateLink(params, config) { 
    return http.post(
    "/fsapi/menu/create_link",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function getMenuInfo(params, config) {
    return http.get("/fsapi/menu/menu_info", merge(config, { params }));
  }

  export function getSideHead(params, config) {
    return http.get("/fsapi/menu/head_side", merge(config, { params }));
  }

  export function getViewList(params, config) {
    return http.get("/fsapi/view/lists", merge(config, { params }));
  }

  export function addView(params, config) { 
    return http.post(
    "/fsapi/view/add",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function editView(params, config) { 
    return http.post(
    "/fsapi/view/edit",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function delView(params, config) { 
    return http.post(
    "/fsapi/view/del",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function feishu_data(params, config) {
    return http.get("/fsapi/feishuDate/page", merge(config, { params }));
  }

  export function feishuInfo(params, config) {
    return http.get("/fsapi/feishuDate/info", merge(config, { params }));
  }

  

  export function feishu_token(params, config) { 
    return http.post(
    "/fsapi/feishuDate/authorization",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function feishuSendMsg(params, config) { 
    return http.post(
    "/fsapi/feishuDate/send_msg",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function feishuAdopt(params, config) { 
    return http.post(
    "/fsapi/feishuDate/adopt",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  
  export function setColumnWidth(params, config) { 
    return http.post(
    "/fsapi/draft/set_column_w",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function feishu_head(params, config) {
    return http.get("/fsapi/feishuDate/header", merge(config, { params }));
  }

  export function getFields(params, config) {
    return http.get("/fsapi/view/get_fields", merge(config, { params }));
  }

  export function setFields(params, config) { 
    return http.post(
    "/fsapi/view/set_field",
    params,
    merge(config, { emulateJSON: false })
  );
  }


  export function getDownloadFiel(params, config) {
    return http.get("/fsapi/task/download_psd", merge(config, { params }));
  }

  export function downloadInfo(params, config) {
    return http.get("/fsapi/feishuDate/download_info", merge(config, { params }));
  }

  export function searchList(params, config) {
    return http.get("/fsapi/feishuDate/search_list", merge(config, { params }));
  }

  export function add_material(params, config) { 
    return http.post(
    "/fsapi/sourceMaterial/add_material",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function getSiftLists(params, config) {
    return http.get("/fsapi/sift/page", merge(config, { params }));
  }

  export function getAssortList(params, config) {
    return http.get("/fsapi/sift/assort_list", merge(config, { params }));
  }

  export function editSift(params, config) { 
    return http.post(
    "/fsapi/sift/edit",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function createTable(params, config) {
    return http.get("/fsapi/spreadsheet/create_table", merge(config, { params }));
  }

  export function sheetEdit(params, config) { 
    return http.post(
    "/fsapi/spreadsheet/add_head",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  export function setTableData(params, config) { 
    return http.post(
    "/fsapi/spreadsheet/set_data",
    params,
    merge(config, { emulateJSON: false })
  );
  }




// WEBPACK FOOTER //
// ./src/api/fsapi.js